import React from 'react'

// @ts-ignore
import RadioGroup from '../../../gd-components/gd-radio-group/gd-radio-group';

type Props = {
    className?  : string

    form?       : any
    name?       : string
    value?      : any

    items       : any[]

    disabled    : boolean
    onChange    :func
}

export default class FormRadioGroup extends React.Component<Props> {

    static defaultProps = {
        disabled: false,
    }

    componentDidMount() {
        if (this.props.form) this.props.form.registerFormComponent(this.props.name, this);
    }

    onChange = (newValue: any) => {
        if (this.props.form) this.props.form.onFormComponentValueChange(this.props.name, newValue);
        if (this.props.onChange) this.props.onChange(newValue);
    }

    render() {
        return <RadioGroup className={this.props.className}
                           value={this.props.form ? this.props.form.getValue(this.props.name) : this.props.value}
                           items={this.props.items}
                           disabled={this.props.disabled}
                           onChange={this.onChange}/>;
    }
}